<template>
  <div>
    <el-card class="box-card boxcard">
      <div slot="header" class="clearfix">
        <b><i class="el-icon-s-unfold"></i>整改单录入</b>
      </div>
      <div class=' contijiao wkbmf loaded' v-if="suprow.cisvencommit=='已确认'">
        <div class='stamp stamp1'> </div>
      </div>
      <div style="width:100%; height:55px">
        <div class="pull-right">
          <!-- <el-button type="danger" plain size="medium" @click.native="UnonSubmit()">撤销提交</el-button> -->

          <Debounce :time='300' :isDebounce="1">
            <el-button type="primary" plain size="medium" @click.native="onSubmit()" :disabled="suprow.cisvencommit=='已确认'">提交</el-button>
          </Debounce>

          <el-upload action="#" ref="uploadFail" style="display:inline-block;margin:0 10px" :disabled="suprow.cisvencommit=='已确认'" :show-file-list="false" :before-upload="brforeUploadreImportFail" :auto-upload="false" :on-change="handleChangeFail" :file-list="fileListFail" :accept="typeaccept">
            <el-button type="success" size="medium" plain :disabled="suprow.cisvencommit=='已确认'">整改单上传({{typeaccept}})</el-button>
          </el-upload>
          <Debounce :time='300' :isDebounce="1">
            <el-button type="warning" plain @click.native="GetHTFileUrl()" size="medium">预览</el-button>
          </Debounce>
          <el-button type="warning" plain size="medium" @click="printpage()">打印</el-button>
          <!-- <el-button type="primary" size="medium">撤销提交</el-button> -->
          <!-- <el-button type="danger" size="medium" @click="DeleteSHInfo">删除</el-button> -->
          <el-button type="info" plain size="medium" @click="returnpage('1')">返回主表</el-button>
          <el-button type="info" plain size="medium" @click="returnpage('2')">返回首页</el-button>
        </div>
      </div>

      <div class="ibox-content ibox-content-width">

        <div class="rowFlexBody">
          <h2 class="titleText">不良反馈报告</h2>
          <h4 class="titleText">（8D 报告）</h4>
        </div>
        <div class="rowFlexBody">
          <table class="layui-table" style="width: 100%">
            <tbody class="bmtrFirstTDgreen">
              <tr>
                <td width="200">报告编号</td>
                <td>{{tableorder.ccode}}</td>
                <td width="200">发出日期</td>
                <td width="35%">{{tableorder.dissuedate}}</td>
              </tr>
              <tr>
                <td>物料名称</td>
                <td>{{tableorder.cpartname}}</td>
                <td>检查员</td>
                <td>{{tableorder.cinspector}}</td>
              </tr>
              <tr>
                <td>公司</td>
                <td>{{tableorder.ccorpname}}</td>
                <td>供应商</td>
                <td>{{tableorder.cvenname}}</td>
              </tr>
              <!-- <tr>
                <td>零（部）件名称</td>
                <td>{{tableorder.cpartname}}</td>
                <td>零（部）件件号</td>
                <td>{{tableorder.cpartnumber}}</td>
              </tr> -->
              <!-- <tr>
                <td>零（部）件件号</td>
                <td>{{tableorder.cpartnumber}}</td>
                <td>供方代码</td>
                <td>{{tableorder.csupcode}}</td>
              </tr> -->
              <tr>
                <td>数量</td>
                <td>{{tableorder.cnumber}}</td>
                <td>整改截止时间</td>
                <td>{{tableorder.dzhenggai}}</td>
              </tr>
              <!-- <tr>
                <td>物料名称</td>
                <td colspan="3">{{tableorder.ccpmodel +tableorder.cpartname+tableorder.cpartnumber}}</td>
              </tr> -->
              <!-- <tr>
                <td>数量</td>
                <td>{{tableorder.cnumber}}</td>
                <td>出厂编号</td>
                <td>{{tableorder.cfactorycode}}</td>
              </tr> -->
              <tr>
                <td>NCR 类型</td>
                <td colspan="3">
                  <el-checkbox v-model="tableorder.cjstype" disabled>技术类型</el-checkbox>
                  <el-checkbox v-model="tableorder.cgltype" disabled>管理类型</el-checkbox>
                  <el-checkbox v-model="tableorder.cbztype" disabled>包装类型</el-checkbox>
                  <el-checkbox v-model="tableorder.cxsdelivery" disabled>信息传递</el-checkbox>
                </td>
              </tr>
              <!-- <tr>
                <td>反馈工序</td>
                <td colspan="3">
                  <el-checkbox v-model="tableorder.cwj" disabled>外检</el-checkbox>
                  <el-checkbox v-model="tableorder.cassembly" disabled>装配线</el-checkbox>
                  <el-checkbox v-model="tableorder.ctestrun" disabled>试车线</el-checkbox>
                  <el-checkbox v-model="tableorder.crk" disabled>入库</el-checkbox>
                  <el-checkbox v-model="tableorder.cmarket" disabled>市场</el-checkbox>
                </td>
              </tr> -->
              <tr>
                <td>不良品处置</td>
                <td colspan="3">
                  <el-checkbox v-model="tableorder.crbreceiving" disabled>让步接收</el-checkbox>
                  <el-checkbox v-model="tableorder.crepair" disabled>返修</el-checkbox>
                  <el-checkbox v-model="tableorder.creturn" disabled>退货</el-checkbox>
                </td>
              </tr>
              <tr>
                <td>问题</td>
                <td colspan="3">{{tableorder.cproblem}}</td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>1. 解决团队：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.cjjteam" id="cjjteam">
                  </el-input>
                </td>
                <td>
                  <el-date-picker v-model="tableorder.djjdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>2. 问题描述：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.cmsproblem" id="cjjteam">
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="cmsproblem" style="margin-top:10px; display:inline-block"></textarea> -->
                </td>
                <td>
                  <el-date-picker v-model="tableorder.dmsdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>3. 临时措施：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.clsmeasures" id="cjjteam">
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="clsmeasures" style="margin-top:10px; display:inline-block"></textarea> -->
                </td>
                <td>
                  <el-date-picker v-model="tableorder.dlsdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>4. 原因分析：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.ccauseanalysis" id="cjjteam">
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="ccauseanalysis" style="margin-top:10px; display:inline-block"></textarea> -->
                </td>
                <td>
                  <el-date-picker v-model="tableorder.dfxdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>5. 长期措施：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.ccqmeasures" id="cjjteam">
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="ccqmeasures" style="margin-top:10px; display:inline-block"></textarea> -->
                </td>
                <td>
                  <el-date-picker v-model="tableorder.dcqdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>6. 措施固化：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.cmeacuring" id="cjjteam">
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="cmeacuring" style="margin-top:10px; display:inline-block"></textarea> -->
                </td>
                <td>
                  <el-date-picker v-model="tableorder.dghdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>7. 措施实施确认：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.cqyss">
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="cqyss" style="margin-top:10px; display:inline-block"></textarea> -->
                </td>
                <td rowspan="3">
                  <el-date-picker v-model="tableorder.cssdate" type="date" placeholder="选择日期" value-format="yyyy-MM-dd">
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td>供应商验证人</td>
                <td>供应商质保部长</td>
                <td>供应商总经理</td>
              </tr>
              <tr>
                <td>
                  <el-input type="text" v-model="tableorder.czrverifier" style="width:160px">
                  </el-input>
                </td>
                <td>
                  <el-input type="text" v-model="tableorder.czrminister" style="width:160px">
                  </el-input>
                </td>
                <td>
                  <el-input type="text" v-model="tableorder.ccrmanager" style="width:160px">
                  </el-input>
                </td>
              </tr>
              <tr>
                <td colspan="3">
                  <span>8. 牧场确认：</span>
                </td>
                <td>日期</td>
              </tr>
              <tr>
                <td colspan="3">
                  <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="tableorder.chfqy" disabled>
                  </el-input>
                  <!-- <textarea class="form-control" rows="3" placeholder="" id="chfqy" style="margin-top:10px; display:inline-block" readonly="readonly"></textarea> -->
                </td>
                <td>
                  <el-date-picker v-model="tableorder.dqydate" type="date" placeholder="选择日期" disabled>
                  </el-date-picker>
                </td>
              </tr>
              <tr>
                <td colspan="4">
                  <ul class="list-style-block" style="margin-left:20px">
                    <li>不良反馈报告在两周内进行反馈关闭</li>
                    <li>不良反馈报告发出后责任供方每天反馈整改进度直至关闭</li>
                  </ul>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </el-card>
    <operprint v-if="prinpageif" :prinpageif="prinpageif" :prinpagesrc="prinpagesrc" @printclose="printclose" />
  </div>
</template>

<script>
import operprint from "../../Operation_SHOrder/Operation/Operatiopint";
import { RemovePruchaseToDo, GetFileType } from "../../../../api/home";
export default {
  components: { operprint },
  data() {
    return {
      // 当前日期
      nowdate: "",
      // 弹出框的日期
      timeval: [],
      tableorder: [],

      prinpageif: false,
      prinpagesrc: "",
      suprow: [],
      checkedCities: [],
      textarea: "",
      fileListFail: [],
      typeaccept: "",
      previnformdata: {},
    };
  },
  created() {
    if (this.$route.params.rows) {
      this.suprow = this.$route.params.rows;
      sessionStorage.setItem("suprow", JSON.stringify(this.$route.params.rows));
      this.previnformdata = this.$route.params.informdata;
      sessionStorage.setItem(
        "informdata",
        JSON.stringify(this.$route.params.informdata)
      );
    } else {
      this.suprow = JSON.parse(sessionStorage.getItem("suprow"));
      this.previnformdata = JSON.parse(sessionStorage.getItem("informdata"));
    }
    this.GetSHDetail();
    this.FileType();
  },
  methods: {
    // 获取文件类型
    FileType() {
      GetFileType({ type: "07" }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.typeaccept = res.data.Data[0].cfileformat;
        }
      });
    },
    // 获取基本信息
    GetSHDetail() {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/GetBadFeedbackInfo",
        data: { KeyValue: this.suprow.id },
      }).then((res) => {
        console.log(res);
        if (res.data.Success) {
          this.tableorder = res.data.Data[0];
          // console.log(this.tableorder.cgltype);
          this.tableorder.cjstype = JSON.parse(this.tableorder.cjstype);
          this.tableorder.cgltype = JSON.parse(this.tableorder.cgltype);
          this.tableorder.cbztype = JSON.parse(this.tableorder.cbztype);
          this.tableorder.cxsdelivery = JSON.parse(this.tableorder.cxsdelivery);
          this.tableorder.cwj = JSON.parse(this.tableorder.cwj);
          this.tableorder.cassembly = JSON.parse(this.tableorder.cassembly);
          this.tableorder.ctestrun = JSON.parse(this.tableorder.ctestrun);
          this.tableorder.crk = JSON.parse(this.tableorder.crk);
          this.tableorder.cmarket = JSON.parse(this.tableorder.cmarket);
          this.tableorder.crbreceiving = JSON.parse(this.tableorder.cassembly);
          this.tableorder.crepair = JSON.parse(this.tableorder.crepair);
          this.tableorder.creturn = JSON.parse(this.tableorder.creturn);
          console.log(JSON.parse(this.tableorder.cgltype));
          // console.log(this.tableorder);
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },
    // 返回
    returnpage(type) {
      sessionStorage.removeItem("params");
      if (type == "1") {
        this.$router.push({
          path: "/RectificationList/RectificationList",
          query: { informdata: this.previnformdata },
        });
      } else {
        this.$router.push({ path: "/home" });
      }
    },
    // 预览
    GetHTFileUrl() {
      if (
        this.tableorder.cfileurl != "" &&
        this.tableorder.cfileurl != undefined
      ) {
        window.open(this.global.BASE_URL + this.tableorder.cfileurl);
      } else {
        this.$message.error("暂无文件！！");
      }
    },

    onSubmit() {
      console.log(this.tableorder);
      this.$confirm("点击确认之后将无法在上传文件, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/QueryBadFeedback",
            data: {
              KeyValue: this.suprow.id,
              JsonInfo: JSON.stringify(this.tableorder),
            },
          }).then((res) => {
            console.log(res, "确认");
            if (res.data.Success) {
              this.$message.success("确认成功！");
              this.removerp();
              this.returnpage("1");
            } else {
              this.$message.error(res.data.Message);
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    // 删除待办事项中的信息
    removerp() {
      RemovePruchaseToDo({
        KeyValue: this.suprow.id,
      }).then((res) => {
        console.log(res);
      });
    },
    //上传文件
    handleChangeFail(file, fileList) {
      this.$refs.uploadFail.submit();
    },
    // 上传文件
    brforeUploadreImportFail(file) {
      this.$axios({
        method: "post",
        url: "CommonModule/Op_Supplier/SupplierCheckAll",
        data: { cbilltype: "整改单上传", cbillid: this.suprow.id },
      }).then((res) => {
        console.log(res, "上传结果果上传结果");
        if (res.data.Success) {
          let varparams = new FormData();
          varparams.append("file", file);
          varparams.append("file", URL.createObjectURL(file));
          varparams.append("cvoucherno", "op_badFeedback");
          varparams.append("ctype", "07");
          varparams.append("cvoucherid", this.suprow.id);
          this.$axios({
            method: "post",
            url: "CommonModule/Op_Supplier/BaseUploadFile",
            headers: { "Content-Type": "multipart/form-data" },
            data: varparams,
            timeout: 30000000,
          }).then((res) => {
            console.log(res, "上传结果");

            if (res.data.Success) {
              this.$message({
                howClose: true,
                message: "上传成功",
                type: "success",
              });
              this.tableorder.cfileurl = res.data.Data.Path;
            } else {
              this.$message.error(res.data.Message);
            }
          });

          return false; //屏蔽了action的默认上传
        } else {
          this.$message.error(res.data.Message);
        }
      });
    },

    // 保存
    SaveSHInfo() {},

    printclose(val) {
      this.prinpageif = val;
    },
    //打印
    printpage() {
      if (this.suprow.id == undefined) {
        this.$message.error("请选中要打印的数据！！");
      }
      if (this.suprow.id != "") {
        this.prinpagesrc =
          this.global.bxios_URL +
          "CommonModule/PrintView/SetPrintViewZG?KeyValue=" +
          this.suprow.id;
        this.prinpageif = true;
      } else {
        this.$message.error("请选中要打印的数据！！");
      }
    },
  },
};
</script>


